import { Add, Remove } from "@mui/icons-material";
import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import faqs from '../../../assets/data/faqs';
import { Link } from "react-router-dom";


const FAQCard = ({ Question, Answer }) => {

  const [height, setHeight] = useState('3');
  const [collapse, setCollapse] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
      
  const defaultHeight = isMobile ? '2' : '3';
  
  React.useEffect(() => {
    if (collapse) {
      setHeight(defaultHeight);
    }
  }, [defaultHeight, collapse]); // Watch both

  const handleCollapse = () => {
    setHeight(prev =>  (prev === defaultHeight ? 'auto' : defaultHeight));
    setCollapse(prev => !(prev));
  }

  return(
    <Box sx={{ width: '100%', height: height === 'auto' ? 'auto' : `${height}vh`, bgcolor: '#55d6aa', borderRadius: '5px', m: 1, p: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }} >
      <Box sx={{ display: 'flex', height: '100%', mb: { xs: 1, md: 1 } }} >
        <Typography fontWeight={500} sx={{ width: '95%', clolor: '#242424', fontSize: { xs: '0.9rem', md: '1.1rem' }, ml: 1, mt: { xs: -0.3, md: 0 } }} >{Question}</Typography>
        <Box sx={{ width: '5%', height: '100%', display: 'flex', justifyContent: 'center', mt: { xs: -0.3, md: 0 } }} >
          {!collapse ?
            <Remove onClick={handleCollapse} sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' }, stroke: '#242424',  }}  />
            :
            <Add onClick={handleCollapse} sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' }, stroke: '#242424',  }} />
          }
        </Box>
      </Box>
      <Box>
        <Typography sx={{ ml: 2, color: '#242424', fontSize: { xs: '0.8rem', md: '0.9rem' } }} >{Answer}</Typography>
      </Box>
    </Box>
  )
}

function FAQsSection() {

  const randomFAQs = faqs.sort(() => 0.5 - Math.random());
  const selectedItems = randomFAQs.slice(0, 8);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          bgcolor: "white",
          mb: 2,
          pb: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <h2>Frequently Asked Questions</h2>
        <Box sx={{ width: { xs: '85%', md: '95%' }, ml: { xs: -3, md: 0 }, display: { xs: 'flex', md: 'grid' }, gridTemplateColumns: '1fr 1fr', flexDirection: { xs: 'column', md: 'none' }, justifyItems: 'center', gap: '0 4rem' }} >
          {selectedItems.map((item) => (
            <FAQCard key={item} Question={item.question} Answer={item.answer} />
          ))}
        </Box>
        <Link to="/faq_s" >
          <Button variant="outlined" sx={{ mt: 4, width: { xs: '30vw', md: '10vw' }, fontSize: { xs: '0.7rem', md: '0.875rem' }, borderColor: '#55d6aa', color: '#242424' }} >See More</Button>
        </Link>
      </Box>
    </>
  );
}

export default FAQsSection;
